/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { NavLink } from "react-router-dom";
import 'components/nav.scss';

export default function FirmNav(props){

  return(
    <nav className='subnav'>

      <NavLink exact to='/firm/users' activeClassName='active'>Users</NavLink>
      <NavLink exact to='/firm/billing' activeClassName='active'>Billing</NavLink>

    
    </nav>
  );
}
